<script>
import {
  defineComponent,
  inject,
  computed,
  watchEffect,
  ref,
  watch,
  nextTick,
} from "vue";
import NavMainSearch from "@kit/components/NavMainSearch.vue";
import { searchWidgetMain, navbar } from "@project/themes";
import NavBarBase from "@kit/components/NavBarBase.vue";
import IconButton from "@kit/components/IconButton.vue";
import Icon from "@kit/components/Icon.vue";
import { inBrowser } from "@kit/utils/EnvironmentHelper";
import { cmsasset } from "@kit/utils/Formats";
import { useStore } from "vuex";
import { dispatchEvent } from '@kit/utils/EventBus'
import { animate, actionSetOA2T, actionOA2T } from '@kit/utils/Animate'
import "@css/index.css";

export default defineComponent({
  name: "NavBar",
  setup() {
    const hydrate = inject("hydrate")
    const navbarTheme = navbar
    const searchWidgetMainTheme = searchWidgetMain
    const atTop = ref(true);
    const hamburgerButton = ref(null)
    const store = useStore()

    const topOn = () => {
      atTop.value = true;
    };
    const topOff = () => {
      atTop.value = false;
    };

    const sideDrawerOut = () => {
      if(store.state.drawerOut) {
        dispatchEvent("drawerMove", false)
        hamburgerButton.value.setAttribute("aria-expanded", false)
      } else {
        dispatchEvent("drawerMove", true)
        hamburgerButton.value.setAttribute("aria-expanded", true)
      }
    }


    const { prefetch } = hydrate({
      prefetch:["common"],
    })
    
    return {
      sideDrawerOut,
      atTop,
      searchWidgetMainTheme,
      navbarTheme,
      cmsasset,
      topOn,
      topOff,
      prefetch
    };
  },
  components: {
    NavMainSearch,
    NavBarBase,
    IconButton,
    Icon,
  },
});
</script>

<style>
.mobile-only {
  display: none;
}
.desktop-only {
  display:block;
}
@media (max-width:900px) {
  .mobile-only {
    display: block
  } 
  .desktop-only {
    display:none;
  }
}
.hamburger-button {
    border-bottom: 4px solid var(--navy) !important;
    border-top: 4px solid var(--navy) !important;
    cursor: pointer;
    height: 30px;
    margin-bottom: 10px;
    margin-right: 20px;
    margin-top: 10px;
    width: 50px;
}

</style>

<template>
  
  <header id="hdr" class="">
  <div class="bar">
    <router-link :to="'/'" class="brand">
      <img v-if="prefetch && prefetch.common" :src="cmsasset(prefetch.common.logo_image.guid)" alt="Treasure Coast Avionics, Inc">
      <div class="cert">FAA Part 145<br>Repair Station</div>
    </router-link>
    <nav class="topnav">
      <a href="/#services">Services</a>
      <a href="/#work">Recent Installs</a>
      <router-link to="/news">News</router-link>
      <a href="/#brands">Brands</a>
      <router-link to="/contact-us">Contact Us</router-link>
      <a href="/#visit">Find Us</a>
      <a class="call-btn desktop-only" href="tel:+17724643148">(772) 464-3148</a>
    </nav>
    <nav class="mobile-only">
      <div @click="sideDrawerOut" role="menu" aria-controls="SideNavDrawer_sideDrawer" aria-haspopup="dialog" aria-expanded="false" 
      aria-label="Button for responsive side-sliding navigation drawer" 
      class="sb sb-h sb-explicit hamburger-button"></div>
    </nav>
  </div>
</header>

</template>
